// extracted by mini-css-extract-plugin
module.exports = {"videoTest":"videoStyles_videoTest__eHJcp"};